import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import BrandIcon from "components/BrandIcon";

const RemovableClient = (props: RemovableProps<server.dto.ClientSmall>) => {
  return <RemovableLabel {...props}>
    <div className="flex gap">
      <div>
        <BrandIcon iconUrl={props.value.iconUrl} name={props.value.name} size={20} />
      </div>
      <div>
        <div>{props.value.name}</div>
      </div>
    </div>
  </RemovableLabel>;
};

export default RemovableClient;